const monthlyServicePrice = ({ monthlyLiquidatedDamages = 0, pickup = 0, ...price }, hasCasters, hasLockbar) => {
  const casters = hasCasters ? price.casters || 0 : 0;
  const lockbar = hasLockbar ? price.lockbar || 0 : 0;
  return pickup + casters + lockbar + monthlyLiquidatedDamages;
};

export default monthlyServicePrice;
